import React, { useState } from 'react'
import getFoodChartOptions from '../../../utils/charts/baseFoodChart'
import ChartModule from './ChartModule'
import TabPanel from '../../layout/TabPanel'
import FoodTable from '../Tables/FoodTable'
import { Box, Card, CardContent, Tab, Tabs, Typography } from '@mui/material'
import { a11yProps } from '../../../constants/constants'
import { type IChartOptionsParams } from '../../../interfaces/chart.interface'

export default function FoodChart (props: IChartOptionsParams): JSX.Element {
  const [selectedFoodTab, setSelectedFoodTab] = useState(0)

  const renderChartPanel = (): JSX.Element => {
    return (
      <Card className='chart-card' sx={{ mb: 8 }} id='food-card'>
        <CardContent sx={{ pt: 0 }}>
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'end', m: 0 }}>
            <Typography variant='h6' color='#7f7f7f'> Food </Typography>
            <Tabs
              sx={{ borderBottom: 1, borderColor: 'divider' }}
              value={selectedFoodTab}
              onChange={(_e, val) => { setSelectedFoodTab(val) }}
              aria-label='Profile tabs'
            >
              <Tab data-testid='food__charts-tab' label='Graph' {...a11yProps('food-metric__tab', 0)} />
              <Tab data-testid='food__table-tab' label='Table' {...a11yProps('food-metric__tab', 1)} />
            </Tabs>
          </Box>
          <TabPanel value={selectedFoodTab} index={0} noPadding>
            <ChartModule
              hideHeader
              hideBorder
              showChartActions
              dashboardViewStore={props.dashboardViewStore}
              memberObj={props.memberObj}
              metricType='food'
              getChartOptions={getFoodChartOptions}
              showMemberAlerts={props.showMemberAlerts}
              handleAlertClick={props.handleAlertClick} // eslint-disable-line react/jsx-handler-names
            />
          </TabPanel>
          <TabPanel value={selectedFoodTab} index={1} noPadding>
            <FoodTable
              hideHeader
              hideBorder
              dashboardViewStore={props.dashboardViewStore}
              memberObj={props.memberObj}
            />
          </TabPanel>
        </CardContent>
      </Card>
    )
  }

  return renderChartPanel()
}
